<template>
    <div class="d-flex justify-space-between align-center pt-8">
        <TitleSection section="filters"/>
        <ButtonText @reset-method="resetFilters"/>
    </div>
</template>

<script>
    import ButtonText from "@/components/filters/ButtonText";
    import TitleSection from "@/components/filters/TitleSection";

    export default {
        name: "ResetFiltersButton",
        components: {
            ButtonText,
            TitleSection
        },
        methods: {
            resetFilters() {
                this.$emit('reset-method');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/filters/ResetFiltersButton.vue